if (!customElements.get('wlsn-cart-note')) {
  class WLSNCartNote extends HTMLElement {
    constructor() {
      super();

      this.debounceTimer = null;
      this.debounceDelay = 800; // 800ms debounce delay

      this.bindMethods = {
        handleInput: this._handleInput.bind(this),
      };
    }

    get elements() {
      return {
        textarea: this.querySelector('textarea'),
      };
    }

    connectedCallback() {
      this._attachEventListeners();
    }

    disconnectedCallback() {
      this._detachEventListeners();
      this._clearDebounceTimer();
    }

    _attachEventListeners() {
      const textarea = this.elements.textarea;
      if (textarea) {
        textarea.addEventListener('input', this.bindMethods.handleInput);
      }
    }

    _detachEventListeners() {
      const textarea = this.elements.textarea;
      if (textarea) {
        textarea.removeEventListener('input', this.bindMethods.handleInput);
      }
    }

    _handleInput(event) {
      const note = event.target.value;

      // Clear existing timer
      this._clearDebounceTimer();
      // Set new timer
      this.debounceTimer = setTimeout(() => {
        this._dispatchNoteChange(note);
      }, this.debounceDelay);
    }

    _dispatchNoteChange(note) {
      window.WLSNHelpers.triggerEvent(this, 'wlsn:cart:note:change', { note });
    }

    _clearDebounceTimer() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
    }
  }
  customElements.define('wlsn-cart-note', WLSNCartNote);
}
